import { httpClient } from '@/core/api/httpClient';
import { env } from '@/core/config/env';
import { API_V1 } from '@/core/api/endpoints';
import type { OnboardingPayload } from '../types';

const USE_MOCK = env.VITE_USE_MOCK === 'true';

export const onboardingService = {
  complete: async (payload: OnboardingPayload): Promise<void> => {
    if (USE_MOCK) return;
    await httpClient.post<OnboardingPayload, void>(`${API_V1}/onboarding`, payload);
  },
};
